import { useState } from "react";

import { useTranslation } from "react-i18next";

import ActionPanelFrame, { ReturnActionPanelProps } from "./ActionPanelFrame";

// Seller-side reasons for eBay's escalate call; the API validates against eBay's EscalateReasonEnum.
const ESCALATE_REASONS: { code: string; label: string }[] = [
  { code: "ITEM_RECEIVED_IN_DIFFERENT_CONDITION", label: "It came back in a different condition to how we sent it" },
  { code: "BUYER_RETURNED_WRONG_ITEM", label: "A different item came back" },
  { code: "RECEIVED_EMPTY_BOX", label: "The box was empty" },
  { code: "RECEIVED_DAMAGED_ITEM", label: "It was damaged in transit on the way back" },
  { code: "ITEM_NOT_RECEIVED", label: "The buyer hasn't sent it back in time" },
  { code: "RESOLVED_WITH_BUYER", label: "Sorted out with the buyer already" },
  { code: "OTHER", label: "Something else (explain in the message)" },
];

/** Ask eBay to step in. Once it has, every option here goes read-only. */
export default function EscalatePanel({ detail, onConfirm, onCancel, busy }: ReturnActionPanelProps) {
  const { t } = useTranslation("returns");
  const [reason, setReason] = useState(ESCALATE_REASONS[0].code);

  return (
    <ActionPanelFrame
      kind="escalate"
      detail={detail}
      confirmLabel={t("Ask eBay to step in")}
      messageHint={t("what you want eBay to know")}
      onConfirm={(message) => onConfirm({ message, escalateReason: reason })}
      onCancel={onCancel}
      busy={busy}
    >
      <div className="rounded-lg border border-red-200 bg-red-50 px-3 py-2.5 text-[12px] text-red-900">
        {t("eBay decides from here. Refunds with a deduction stop being available, and the outcome can count against seller performance.")}
      </div>
      <label className="flex flex-col gap-1 text-[12px] text-gray-700">
        {t("Why")}
        <select value={reason} onChange={(e) => setReason(e.target.value)} disabled={busy} className="rounded-lg border border-gray-300 bg-white py-2 pl-2.5 pr-8 text-[12px] focus:border-primary-500 focus:ring-primary-500">
          {ESCALATE_REASONS.map((r) => (
            <option key={r.code} value={r.code}>
              {t(r.label)}
            </option>
          ))}
        </select>
      </label>
    </ActionPanelFrame>
  );
}
